import React from "react";

import { Descriptions } from "antd";

export const AdminDescriptions = ({ items, columns, extra = null, title = null }) => (
  <Descriptions bordered size="small" items={items} column={columns || 3} extra={extra || <></>} title={title} />
);

export default AdminDescriptions;
